<div
    class="flex flex-col p-4 gap-4 justify-start items-center"
    id="thumbnail-container"
  >
    <div
      class="thumbnail relative h-30 w-30 border-solid border-4"
      [class.border-blue]="isInFocus"
      [class.border-transparent]="!isInFocus"
    >
      <img
        [src]="photo?.url"
        alt="Photo"
        class="h-full w-full object-cover"
        (click)="onPhotoClicked()"
      />

      <input
        type="checkbox"
        class="absolute top-2 right-2 w-5 h-5 z-9 accent-blue"
        (click)="onSelectClick($event)"
        [checked]="photo?.selected"
      />
    </div>

    <section
      class="thumbnail-details flex flex-col gap-1 justify-center items-start w-30"
    >
      <span class="thumbnail-description text-sm line-clamp-2">{{
        photo?.description
      }}</span>
      <div
        class="thumbnail-meta-info text-neptune-color-fg-muted text-xs flex flex-col"
      >
        <span class="thumbnail-date">{{ photoObject?.endDate }}</span
        ><span class="thumbnail-ecolab-rep">{{ photoObject?.ecolabRep }}</span>
      </div>
    </section>
  </div>

